module.exports = __webpack_public_path__ + "static/media/bj.9ec46b3a.svg";